module.exports = __webpack_public_path__ + "media/mjollnir2.1e9431f1.webm";